import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, CheckCircle, ArrowRight, Bell } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface RecommendationModalProps {
  isOpen: boolean;
  onClose: () => void;
  recommendation: string;
  onValidate: () => void;
  onPostpone: () => void;
}

export function RecommendationModal({
  isOpen,
  onClose,
  recommendation,
  onValidate,
  onPostpone
}: RecommendationModalProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="w-full max-w-md"
        >
          <Card className="p-6 bg-white shadow-xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-purple-100 rounded-lg">
                <Bell className="w-6 h-6 text-purple-600" />
              </div>
              <h2 className="text-xl font-bold">Rappel de recommandation</h2>
            </div>

            <div className="bg-purple-50 p-4 rounded-lg mb-6">
              <p className="whitespace-pre-line text-purple-900">{recommendation}</p>
            </div>

            <div className="space-y-3">
              <Button
                onClick={onValidate}
                className="w-full gap-2"
              >
                <CheckCircle className="w-4 h-4" />
                J'ai suivi cette recommandation
              </Button>

              <Button
                variant="outline"
                onClick={onPostpone}
                className="w-full gap-2"
              >
                <Clock className="w-4 h-4" />
                Me rappeler dans 15 minutes
              </Button>

              <Button
                variant="outline"
                onClick={() => navigate('/barometre/recommendations')}
                className="w-full gap-2"
              >
                <ArrowRight className="w-4 h-4" />
                Voir toutes mes recommandations
              </Button>
            </div>
          </Card>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}